export interface DepartmentsModel {
  id?: number;
  orgId?: number;
  name: string;
  description?: string;
  image?: any;
  type?: string;
  isActive?: boolean;
  availableHours?: AvailableHour[];
  adminId?: number;
  departmentUnits?: DepartmentUnit[];
  admin?: Admin;
}

export interface AvailableHour {
  open: string;
  close: string;
}

export interface DepartmentUnit {
  id: number;
  orgId: number;
  departmentId: number;
  name: string;
  description: string;
  image: string;
  isActive: boolean;
  type: string;
  availableHours: AvailableHour2[];
  adminId: number;
}

export interface AvailableHour2 {
  open: string;
  close: string;
}

export interface Admin {
  id: number;
  fullName: string;
  avatar: any;
  password: string;
  photo: any;
  email: string;
  phone: string;
  address: string;
  isActive: boolean;
  position: any;
  country: string;
  city: string;
  passportNumber: any;
  orgId: number;
  workStartTime: any;
  workEndTime: any;
  isVerified: boolean;
  verificationCode: string;
  verificationCodeExpires: string;
  passwordLastChange: string;
  departmentUnitId: any;
  departmentId: any;
  createdAt: string;
}

export interface DepartmentReqModel {
  name?: string;
  adminId?: any;
  type: any;
  description: string;
  availableHours?: { open: any; close: any }[];
  assignedAdmin?: any;
  departmentName?: string;
}

export enum DepartmentType {
  ACCOUNTING_AND_FINANCE = 'Accounting and Finance',
  HUMAN_RESOURCES = 'Human Resources',
  FOOD_AND_BEVERAGE = 'Food and Beverage',
  FRONT_OFFICE = 'Front Office',
  HOUSEKEEPING = 'Housekeeping',
  SALES_AND_MARKETING = 'Sales and Marketing',
  MAINTENANCE_AND_ENGINEERING = 'Maintenance and Engineering',
  SECURITY = 'Security',
  IT_AND_SYSTEMS = 'IT and Systems',
  SPA_AND_WELLNESS = 'Spa and Wellness',
  EVENTS_AND_CONFERENCES = 'Events and Conferences',
  TRANSPORT = 'Transport'
}
